<template>
  <div class="crumbs-box">
    <span style="width: 82%;display: inline-block;">
      <i :class="activeItem.cicon" aria-hidden="true"></i>
      {{activeItem.ct}}
    </span>
    <span style="width: 15%;display: inline-block;" v-show="login">{{`${desc.current}${login}`}}</span>
    <span v-show="login" @click="logout">{{desc.exit}}</span>
  </div>
</template>

<script>
export default {
  props: {
    activeItem: {
      type: Object,
      default: null
    },
    desc: {
      type: Object,
      default: null
    },
    login: {
      type: String,
      default: null
    }
  },
  methods: {
    logout() {
      this.$emit("exit");
    }
  }
};
</script>

<style lang="scss" scoped>
.crumbs-box {
  height: 44px;
  line-height: 44px;
  padding: 0 20px;
  margin-bottom: 20px;
  font-size: 14px;
  background-color: #fff;
  box-shadow: 0 1px 0 0 #ddd;
  > i {
    margin-right: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/crumbs.vue